"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrialBookingModule = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var error_helper_const_1 = require("@const/error-handling/error-helper.const");
var input_output_helper_const_1 = require("@const/input-output-helper.const");
var input_mapping_const_1 = require("@const/input.mapping.const");
var ci_component_injector_service_1 = require("@services/ci-component-injector.service");
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var error_const_1 = require("@src/const/error-handling/error.const");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var magicline_api_1 = require("../../../api/magicline-api");
var studio_dropdown_helper_1 = require("./helpers/studio-dropdown.helper");
var trial_booking_helper_1 = require("./helpers/trial-booking.helper");
var brings_a_friend_helper_1 = require("./helpers/brings-a-friend.helper");
var TrialBookingModule = /** @class */ (function () {
    function TrialBookingModule() {
        this.magiclineApi = object_service_1.ObjectService.getInstance(magicline_api_1.MagiclineApi);
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.interComService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.validBirthdayModule = false;
        // public mapping: { 'data-no-future-dates': boolean };
        // public settings: { noFutureDates: boolean };
        this.trialBookingMapping = input_mapping_const_1._TrialBookingMapping;
        this.trialBookins = {
            description: '',
            name: '',
            slots: [],
        };
        // yond
        this.isYond = false;
        // Give event listener access to ".this" context
        this.handleDatepickerChangeEvent = this.handleDatepickerChangeEvent.bind(this);
        this.slotSelected = this.slotSelected.bind(this);
        this.submitTrialBooking = this.submitTrialBooking.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
        this.studioLocationDropdownSelected = this.studioLocationDropdownSelected.bind(this);
    }
    TrialBookingModule.prototype.sendForm = function () {
        throw new Error('Method not implemented.');
    };
    //TODO: TYPESAFETY FOR SETTINGS
    TrialBookingModule.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dropdownClass_1, dimensions, datePickerQuery, datepickerColorObject, datePickerColors, submitButtonQuery, submitbutton;
            var _this = this;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                if (((_a = this.config.get) === null || _a === void 0 ? void 0 : _a.technologyType) === 'yond') {
                    this.isYond = true;
                }
                // base style classes
                (0, cash_dom_1.default)('head').append((0, trial_booking_helper_1.getTrialBookingBaseStyles)());
                // load ci-components
                (0, ci_component_injector_service_1._InjectStencilWebComponents)();
                // replace runtime placeholders with tags so we can adjust them later
                (0, trial_booking_helper_1.addInitialPlaceholderTags)(this.$container);
                // initial selected date
                this.selectedStartDate = new Date();
                this.selectedEndDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
                this.selectedDate = (0, trial_booking_helper_1.getCurrentDate)();
                this.trialBookingMapping = (0, trial_booking_helper_1.getTrialBookingFieldMapping)(this.$container);
                // location selection element
                // TODO: accept local storage so user can set it outside of this module
                this.locationSelection = this.$container.find('*[data-module="dropdown"][data-type="studioLocation"]');
                if (this.locationSelection.length != 0) {
                    this.locationSelection.on('change', this.studioLocationDropdownSelected);
                }
                if ((_c = (_b = this.module.references) === null || _b === void 0 ? void 0 : _b.studioDropdown) === null || _c === void 0 ? void 0 : _c.domElement) {
                    dropdownClass_1 = object_service_1.ObjectService.getInstance(studio_dropdown_helper_1.StudioDropdown);
                    dropdownClass_1.getStudios(this.config).then(function () {
                        var _a, _b;
                        dropdownClass_1.updateDropdown((_b = (_a = _this.module.references) === null || _a === void 0 ? void 0 : _a.studioDropdown) === null || _b === void 0 ? void 0 : _b.domElement);
                    });
                    this.module.references.studioDropdown.domElement.on('change', this.studioLocationDropdownSelected);
                    if ((_e = (_d = this.module.references) === null || _d === void 0 ? void 0 : _d.studioSearch) === null || _e === void 0 ? void 0 : _e.domElement) {
                        this.module.references.studioSearch.domElement.on('input', function (event) {
                            var _a, _b;
                            var selectedValue = (0, cash_dom_1.default)(event.target).val();
                            dropdownClass_1.updateDropdown((_b = (_a = _this.module.references) === null || _a === void 0 ? void 0 : _a.studioDropdown) === null || _b === void 0 ? void 0 : _b.domElement, selectedValue);
                        });
                        this.module.references.studioSearch.domElement.on('keydown', function (event) {
                            if (event.key === 'Enter') {
                                event.preventDefault();
                            }
                        });
                        this.module.references.studioSearch.domElement
                            .attr('type', 'search') // Makes it a search input (optional but improves UX)
                            .attr('enterkeyhint', 'search') // Suggests "Done" instead of "Go"/"Next" on mobile keyboard
                            .attr('autocomplete', 'off'); // Prevents browser autofill
                    }
                }
                (0, brings_a_friend_helper_1.setupBringsAFriendForm)(this.$container, this.module.references);
                dimensions = (0, trial_booking_helper_1.isMobileScreenSize)() ? '{"dayWidth": 40, "dayHeight": 40}' : '{"dayWidth": 50, "dayHeight": 50}';
                datePickerQuery = this.$container.find('*[data-ref="datepicker"]');
                if (datePickerQuery.length > 0) {
                    datepickerColorObject = (_g = (_f = this.config.get) === null || _f === void 0 ? void 0 : _f.trialBooking) === null || _g === void 0 ? void 0 : _g.colors;
                    datePickerColors = datepickerColorObject
                        ? 'colors="' + JSON.stringify(datepickerColorObject).replace(/"/g, "'") + '"'
                        : '';
                    this.datePicker = (0, cash_dom_1.default)("<ci-datepicker open=\"true\" close-on-selection=\"false\" dimensions='".concat(dimensions, "' ").concat(datePickerColors, " animations=\"false\" disable-past-days=\"true\" disable-future-days=\"true\"></ci-datepicker>"));
                    this.changeDatepickerStatus('disabled');
                    datePickerQuery.append(this.datePicker);
                    datePickerQuery.on('change', 'ci-datepicker', this.handleDatepickerChangeEvent);
                }
                else {
                    console.error("Trial booking module missing a data-ref='datepicker' container");
                }
                // error display
                this.errorContainer = (0, cash_dom_1.default)('<div style="display:flex;flex-wrap:wrap;"></div>');
                // slot picker
                this.slotPicker = this.$container.find('*[data-ref="slotpicker"]');
                if (this.slotPicker.length > 0) {
                    this.resetSlotSelectContainer();
                    // TODO Read data styles for elements
                }
                else {
                    console.error("Trial booking module missing a data-ref='slotpicker' container");
                }
                // form
                this.formWrapper = this.$container.find('*[data-ref="form"]');
                if (this.formWrapper.length > 0) {
                    this.formWrapper.css({
                        display: 'none',
                    });
                    // TODO Read data styles for elements
                }
                else {
                    console.error("Trial booking module missing a data-ref='form' container");
                }
                submitButtonQuery = this.$container.find('*[data-action="trailbooking.submit"]');
                if (submitButtonQuery.length > 0) {
                    console.log('Found a submit button');
                    submitButtonQuery.off();
                    submitButtonQuery.on('click', this.submitTrialBooking);
                }
                else {
                    console.error("no button with data-action='trailbooking.submit' found!");
                }
                // prevent enter submit of the form, or any other indirect submitions
                if (submitButtonQuery.length > 0) {
                    submitbutton = submitButtonQuery.closest('form');
                    (0, input_output_helper_const_1._OverwriteIndirectFormSubmit)(submitbutton, function () {
                        _this.submitTrialBooking();
                    });
                }
                // webflow submit button
                this.webflowSubmitButton = this.$container.find('*[data-action="webflow-submit"]');
                if (this.webflowSubmitButton.length === 0) {
                    console.error("no button with data-action='webflow-submit' found!");
                }
                // back button
                this.backButton = this.$container.find('*[data-action="back"]');
                if (this.backButton.length > 0) {
                    console.log('Found a back button');
                    this.backButton.on('click', this.handleBackButton);
                }
                // selected slot display
                // default format is "[from] - [to], [day] [month], [year]"
                // only displayed when slot is selected (when the customer enters the form)
                this.selectedSlotWrapper = this.$container.find('*[data-get="selectedSlot"]');
                if (this.selectedSlotWrapper.length > 0) {
                    this.selectedSlotWrapper.css({
                        display: 'none',
                    });
                    this.selectedSlotElement = (0, cash_dom_1.default)('<div></div>');
                    this.selectedSlotWrapper.append(this.selectedSlotElement);
                }
                // validation birthday
                this.interComService.subscribeChildren(this).subscribe(function (event) {
                    if (event.event === 'validation' && event.module.moduleKey === 'birthday') {
                        _this.validBirthdayModule = event.value.valid;
                        if (event.value.valid) {
                            console.log('Birthday Module event received', event.value.valid);
                            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._BirthdayForm.age, event.value.data.age);
                            (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._BirthdayForm.dateOfBirth, event.value.data.birthday);
                        }
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    TrialBookingModule.prototype.resetSlotSelectContainer = function () {
        var errorContainerContent = this.errorContainer.detach();
        this.slotPicker.empty();
        // dont render error div if no errors exist
        if (errorContainerContent.children().length > 0) {
            this.slotPicker.append(errorContainerContent);
        }
    };
    TrialBookingModule.prototype.handleBackButton = function (event) {
        event.preventDefault();
        console.log('back button clicked');
        this.formWrapper.css({
            display: 'none',
        });
        this.selectedSlotWrapper.css({
            display: 'none',
        });
    };
    TrialBookingModule.prototype.getTrailBookingSlots = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, year_1, month_1, today, currentDay_1, daysInMonth, slots, _b, e_1;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(this.selectedStartDate && this.selectedEndDate && this.studioId)) return [3 /*break*/, 4];
                        if (this.isYond) {
                            _a = this.datePickerDate.split('-').map(Number), year_1 = _a[0], month_1 = _a[1];
                            today = new Date();
                            currentDay_1 = today.getUTCFullYear() === year_1 && today.getUTCMonth() + 1 === month_1 ? today.getUTCDate() : 1;
                            daysInMonth = new Date(year_1, month_1, 0).getDate();
                            slots = Array.from({ length: daysInMonth - currentDay_1 + 1 }, function (_, i) {
                                var day = i + currentDay_1;
                                var start = new Date(Date.UTC(year_1, month_1 - 1, day, 0, 0, 0));
                                var end = new Date(Date.UTC(year_1, month_1 - 1, day, 23, 59, 0));
                                return {
                                    startDateTime: start.toISOString(),
                                    endDateTime: end.toISOString(),
                                };
                            });
                            this.trialBookins = {
                                description: 'Test',
                                name: 'Test',
                                slots: slots,
                            };
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        (0, error_helper_const_1._RemoveStatusFromDomObject)(this.errorContainer);
                        (0, generator_const_1._CreateLoadingScreen)(this.slotPicker);
                        _b = this;
                        return [4 /*yield*/, this.magiclineApi
                                .getTrialBookings(+this.studioId, this.selectedStartDate, this.selectedEndDate)
                                .catch(function (e) {
                                console.log('error getting trail bookins, maybe bad request', e);
                                (0, error_helper_const_1._AddErrorToDomObject)(_this.errorContainer, error_const_1._ErrorMessages['failedGettingTrailBookings'].de);
                                return {
                                    description: '',
                                    name: '',
                                    slots: [],
                                };
                            })];
                    case 2:
                        _b.trialBookins = _c.sent();
                        (0, generator_const_1._DeleteLoadingScreen)(this.slotPicker);
                        if (this.trialBookins.slots.length === 0) {
                            console.log('adding error to dom');
                            (0, error_helper_const_1._AddErrorToDomObject)(this.errorContainer, error_const_1._ErrorMessages['studioHasNoTrialBookings'].de);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        console.error('Error trying to get magicline trail-booking slots:', e_1);
                        this.trialBookins = {
                            description: '',
                            name: '',
                            slots: [],
                        };
                        (0, error_helper_const_1._AddErrorToDomObject)(this.errorContainer, error_const_1._ErrorMessages['failedGettingTrailBookings'].de);
                        (0, generator_const_1._DeleteLoadingScreen)(this.slotPicker);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TrialBookingModule.prototype.updateTrialBookings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var uniqueDays, datepicker;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTrailBookingSlots()];
                    case 1:
                        _a.sent();
                        uniqueDays = this.getUniqueDays(this.trialBookins);
                        this.datePicker.prop('highlight-days', uniqueDays);
                        datepicker = (0, cash_dom_1.default)('ci-datepicker')[0];
                        datepicker.highlightDays = uniqueDays;
                        return [2 /*return*/];
                }
            });
        });
    };
    // takes the trial booking slots and returns unique dates of each day
    TrialBookingModule.prototype.getUniqueDays = function (trialBookins) {
        return (0, trial_booking_helper_1.getUniqueTrialBookingDays)(trialBookins);
    };
    TrialBookingModule.prototype.updateSlotSelection = function () {
        var _this = this;
        var applicableSlots = this.trialBookins.slots.filter(function (slot) { return slot.startDateTime.split('T')[0] === _this.selectedDate; });
        console.log('applicable slots:', applicableSlots, 'for selected date', this.selectedDate, '(all slots:', this.trialBookins.slots, ')');
        this.resetSlotSelectContainer();
        var slotWrapper = (0, cash_dom_1.default)('<div style="display:flex;flex-wrap:wrap;margin-top: 1.5em;"></div>');
        applicableSlots.forEach(function (slot) {
            var _a, _b;
            var slotDetails = (0, trial_booking_helper_1.slotToDetails)(slot);
            // a slot has two elements, a div and a span for the text
            // it uses base classes we design here and adds classes for the designer to write
            // the non base classes come after the base classes to overwrite the base style
            var startTime = slotDetails.formattedStartTime;
            var endTime = slotDetails.formattedEndTime;
            var slotText = _this.isYond ? 'Ganzer Tag' : startTime + ' - ' + endTime;
            var slotDiv = (0, cash_dom_1.default)('<div class="fittec-trial-booking-slot-wrapper"></div>');
            var slotSpan = (0, cash_dom_1.default)('<span class="fittec-trial-booking-slot-text"></span>').text(slotText);
            if (slot.startDateTime === ((_a = _this.selectedSlot) === null || _a === void 0 ? void 0 : _a.startDateTime) && slot.endDateTime === ((_b = _this.selectedSlot) === null || _b === void 0 ? void 0 : _b.endDateTime)) {
                slotDiv.addClass('fittec-trial-booking-slot-wrapper-selected');
                slotSpan.addClass('fittec-trial-booking-slot-text-selected');
            }
            slotDiv.append(slotSpan);
            slotDiv.on('click', function () { return _this.slotSelected(slot); });
            slotWrapper.append(slotDiv);
        });
        this.slotPicker.append(slotWrapper);
    };
    TrialBookingModule.prototype.slotSelected = function (slot) {
        var _a;
        console.log('selected slot', slot);
        this.selectedSlot = slot;
        this.formWrapper.css({
            display: 'block',
        });
        if ((_a = this.selectedSlotWrapper) === null || _a === void 0 ? void 0 : _a.length) {
            this.selectedSlotWrapper.css({
                display: 'block',
            });
            this.setSelectedSlotWrapperText();
        }
        // load pre-existing data from local storage
        this.readLocalStorage();
        // render slot selection
        this.updateSlotSelection();
        // fill hidden fields
        this.fillHiddenFields(slot);
        // replace placeholders that use selected slot info
        (0, trial_booking_helper_1.replaceTrialBookingPlaceholdersTimeslots)(this.$container, this.selectedSlot);
    };
    TrialBookingModule.prototype.readLocalStorage = function () {
        (0, trial_booking_helper_1.readTrialBookingLocalStorage)(this.$container, this.trialBookingMapping);
    };
    // is a studio selection dropdown was found inside the trial-booking module use it to set studioId
    TrialBookingModule.prototype.studioLocationDropdownSelected = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var selectedValue, datepicker;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        selectedValue = (0, cash_dom_1.default)(event.target).val();
                        console.log('Selected studio location:', selectedValue);
                        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.studioId, selectedValue.toString());
                        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._YondMapping.studioOid, selectedValue.toString());
                        if (this.isYond) {
                            this.slotPicker.css({
                                display: 'none',
                            });
                        }
                        // hide form again
                        this.formWrapper.css({
                            display: 'none',
                        });
                        this.selectedSlotWrapper.css({
                            display: 'none',
                        });
                        this.selectedSlot = undefined;
                        this.resetSlotSelectContainer();
                        if (!((typeof selectedValue === 'string' || typeof selectedValue === 'number') && selectedValue !== 'Bitte wählen')) return [3 /*break*/, 2];
                        this.studioId = selectedValue.toString();
                        this.changeDatepickerStatus('enabled');
                        return [4 /*yield*/, this.updateTrialBookings()];
                    case 1:
                        _a.sent();
                        this.updateSlotSelection();
                        return [3 /*break*/, 3];
                    case 2:
                        // this happens if the first STUDIO option is selected with no value
                        // reset to nothing
                        this.trialBookins = {
                            description: '',
                            name: '',
                            slots: [],
                        };
                        datepicker = (0, cash_dom_1.default)('ci-datepicker')[0];
                        datepicker.highlightDays = [];
                        this.changeDatepickerStatus('disabled');
                        this.formWrapper.css({
                            display: 'none',
                        });
                        this.slotPicker.css({
                            display: 'none',
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // get datepicker month + year, make sure to use UTC to prevent conversion errors
    // start is first day of that month, end is last day of the month
    // careful with right dates, if span is bigger than a month, API throws error
    TrialBookingModule.prototype.handleDatepickerChangeEvent = function (event) {
        var _a, _b, _c;
        console.log('datepicker event', event);
        // new month selected
        if (((_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.type) === 'days-view') {
            try {
                var newDate = event.detail.data.value.year + '-' + event.detail.data.value.month + '-' + event.detail.data.value.day;
                if (this.datePickerDate != newDate) {
                    console.log('refreshing to new date, old:', this.datePickerDate, 'new', newDate);
                    this.datePickerDate = newDate;
                    var startDate = new Date(Date.UTC(event.detail.data.value.year, event.detail.data.value.month, 1));
                    var endDate = new Date(Date.UTC(event.detail.data.value.year, event.detail.data.value.month + 1, 0));
                    // start date uses first day of the selected month, if we currently are in this month, skip the days already in the past
                    if (startDate < new Date()) {
                        startDate = new Date();
                    }
                    this.selectedStartDate = startDate;
                    this.selectedEndDate = endDate;
                    // if the end date is in the past, dont load anything
                    if (endDate > new Date()) {
                        this.updateTrialBookings();
                    }
                }
            }
            catch (e) {
                console.error('failed getting date from datepicker:', e);
            }
        }
        else if (((_c = event.detail) === null || _c === void 0 ? void 0 : _c.statusText) === 'value-changed') {
            // day selected
            console.log('value changed!');
            this.selectedDate = event.detail.data;
            if (this.isYond) {
                this.formWrapper.css({
                    display: 'block',
                });
            }
            else {
                this.slotPicker.css({
                    display: 'block',
                });
                this.formWrapper.css({
                    display: 'none',
                });
                this.selectedSlotWrapper.css({
                    display: 'none',
                });
            }
            this.updateSlotSelection();
        }
    };
    TrialBookingModule.prototype.submitTrialBooking = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var validationRes, customerData, dropdownClass, participantData, participantInputCount, participants, bookingData, e_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (event) {
                            event.preventDefault();
                        }
                        (0, generator_const_1._HideErrorMessage)();
                        if ((0, cash_dom_1.default)(event === null || event === void 0 ? void 0 : event.target).hasClass('triggered-submit'))
                            return [2 /*return*/];
                        console.log('submit!');
                        validationRes = (0, input_output_helper_const_1._ValidateFields)(this.formWrapper, {
                            showErrors: true,
                            showSuccess: false,
                            animateToFirstError: true,
                            mappings: this.trialBookingMapping,
                        }, true);
                        console.log('validation res', validationRes);
                        // TODO:  event.fire()
                        // create event with custom attribute to let through
                        if (!this.selectedSlot && ((_a = this.config.get) === null || _a === void 0 ? void 0 : _a.technologyType) !== 'yond') {
                            console.error('No slot selected for trial session!');
                            return [2 /*return*/];
                        }
                        if (!(validationRes.valid && (this.validBirthdayModule || this.$container.find("[data-module='birthday']").length === 0))) return [3 /*break*/, 5];
                        // whole booking data
                        (0, generator_const_1._CreateLoadingScreen)(this.formWrapper);
                        customerData = validationRes.data.customer;
                        if (((_b = this.config.get) === null || _b === void 0 ? void 0 : _b.technologyType) === 'yond') {
                            // for yond we have to make sure it starts with the +49 or whatever
                            if (!customerData.telephone_mobile.includes('+')) {
                                (0, generator_const_1._ShowErrorMessage)('Die Telefonnummer muss mit "+" anfangen');
                                (0, generator_const_1._DeleteLoadingScreen)(this.formWrapper);
                                return [2 /*return*/];
                            }
                        }
                        dropdownClass = object_service_1.ObjectService.getInstance(studio_dropdown_helper_1.StudioDropdown);
                        participantData = (0, brings_a_friend_helper_1.readTrialBookingFriendParticipants)(this.$container);
                        participantInputCount = Number(validationRes.data.participants);
                        participants = participantData.length
                            ? participantData.length + 1
                            : Number.isNaN(participantInputCount)
                                ? undefined
                                : participantInputCount;
                        bookingData = (0, trial_booking_helper_1.createTrialBookingData)(this.selectedSlot, +this.studioId, customerData, this.config, dropdownClass, this.selectedDate, { participants: participants, participantData: participantData });
                        console.log('booking data', bookingData);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.magiclineApi.createTrialBooking(bookingData)];
                    case 2:
                        _c.sent(); // unified endpoint for yond and magicline
                        (0, generator_const_1._DeleteLoadingScreen)(this.formWrapper);
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _c.sent();
                        console.error('Error trying to create a trail booking:', e_2);
                        (0, generator_const_1._DeleteLoadingScreen)(this.formWrapper);
                        return [2 /*return*/];
                    case 4:
                        this.webflowSubmitButton.addClass('triggered-submit').trigger('click').removeClass('triggered-submit');
                        return [3 /*break*/, 6];
                    case 5:
                        console.error('trail booking form validation failed:', validationRes, 'birthday: ', this.validBirthdayModule);
                        (0, generator_const_1._ShowErrorMessage)('Bitte alle Felder ausfüllen');
                        _c.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    TrialBookingModule.prototype.setSelectedSlotWrapperText = function () {
        this.selectedSlotElement.remove();
        this.selectedSlotElement = (0, trial_booking_helper_1.createSelectedTimeslotContainer)(this.selectedSlot);
        this.selectedSlotWrapper.append(this.selectedSlotElement);
    };
    TrialBookingModule.prototype.changeDatepickerStatus = function (newStatus) {
        if (newStatus == 'enabled') {
            this.datePicker.attr('disable-future-days', 'false');
            this.datePicker.attr('disable-past-days', 'false');
        }
        else {
            this.datePicker.attr('disable-future-days', 'true');
            this.datePicker.attr('disable-past-days', 'true');
        }
    };
    TrialBookingModule.prototype.fillHiddenFields = function (slot) {
        (0, trial_booking_helper_1.fillTrialBookingHiddenFields)(this.$container, slot);
    };
    return TrialBookingModule;
}());
exports.TrialBookingModule = TrialBookingModule;
